/**
 * @description Last-known pack-chrome hint for this browser user (LYN-361)
 *
 * Key features:
 * - Persists GET /features/pack-chrome so refresh does not fail-open to LynxPay
 * - No second feature-flag table — same pack-chrome endpoint is the SoT
 *
 * @dependencies none
 *
 * @notes Keyed by signed-in users.id when known. Boot paths without a user id
 *   read the last hint written on this origin. Views never slug-check.
 */

export const PACK_CHROME_HINT_KEY = 'lynx.packChrome.towtechSoChrome';

/**
 * @param {string|number|null|undefined} userId
 * @returns {string}
 */
export function packChromeHintKey(userId) {
  return userId ? `${PACK_CHROME_HINT_KEY}.${userId}` : PACK_CHROME_HINT_KEY;
}

/**
 * @param {string|number|null|undefined} [userId]
 * @returns {boolean|null} true/false when a hint exists, otherwise null
 */
export function readPackChromeHint(userId) {
  try {
    if (userId) {
      const scoped = localStorage.getItem(packChromeHintKey(userId));
      if (scoped === '1') return true;
      if (scoped === '0') return false;
    }
    const last = localStorage.getItem(PACK_CHROME_HINT_KEY);
    if (last === '1') return true;
    if (last === '0') return false;
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {boolean} enabled
 * @param {string|number|null|undefined} [userId]
 */
export function writePackChromeHint(enabled, userId) {
  const value = enabled ? '1' : '0';
  try {
    localStorage.setItem(PACK_CHROME_HINT_KEY, value);
    if (userId) {
      localStorage.setItem(packChromeHintKey(userId), value);
    }
  } catch {
    // quota / private mode — fail open to the in-memory resolve
  }
}

/**
 * Pack-auth SO trees. Keep in lockstep with App.js /so routes.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isSoAppPath(pathname) {
  return pathname === '/so' || pathname.startsWith('/so/');
}
